// Pantalla `command="info"`. Igual que error pero con un fallback de
// data.infoPage.message si existe (variante usada por algunas required
// actions). Título: infoPage.header (messageHeader de Keycloak) si lo hay.
// Botón "Volver" popup-aware si hay infoPage.url, o "Continuar" si hay
// infoPage.actionUrl (continuar el flujo, p. ej. reintentar el código de un
// dispositivo). Sin ninguno de los dos (skipLink), solo el mensaje.

import type { KcData } from "../kcData";
import { PopupAwareBackButton } from "../components/PopupAwareBackButton";
import { StandardPage } from "../components/StandardPage";
import { msg } from "../i18n";

interface InfoPageData {
  message?: string;
  header?: string;
  url?: string;
  actionUrl?: string;
}

function getInfoPage(data: KcData): InfoPageData | undefined {
  return (
    (data.form?.infoPage as InfoPageData | undefined) ??
    (data as unknown as { infoPage?: InfoPageData }).infoPage
  );
}

export interface InfoPagePropsT {
  data: KcData;
}

export function InfoPage({ data }: InfoPagePropsT) {
  const infoPage = getInfoPage(data);
  const message = infoPage?.message ?? data.message?.summary ?? "";

  return (
    <StandardPage page="info" data={data} title={infoPage?.header}>
      <div className="kc-info-message">
        <p
          className="instruction"
          dangerouslySetInnerHTML={{ __html: message }}
        />
        {infoPage?.url ? (
          <p>
            <PopupAwareBackButton href={infoPage.url} />
          </p>
        ) : infoPage?.actionUrl ? (
          <p>
            <a
              href={infoPage.actionUrl}
              role="button"
              className="btn btn-lg btn-block btn-primary"
            >
              {msg("doContinue")}
            </a>
          </p>
        ) : null}
      </div>
    </StandardPage>
  );
}
